module.exports = __webpack_public_path__ + "static/media/2020.4.30垃圾分类整治.6aa2cdd7.jpg";